@let selectedRecords = selectedRecordsSg();
@let records = recordsSg();
@let isSubmitting =
  assignedEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let isLoading =
  assignableEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let recordsSectionTitle = recordsSectionTitleSg();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-assign-records-to-cluster-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-assign-records-to-cluster-modal__content">
        <!-- Campus / Building / Floor filter dropdowns (leaf entity excluded) -->
        <atn-space-dimension-filter
          [plugin]="dimensionFilterPlugin"
          [excludeLeaf]="true"
        />

        <!-- Records section: header + selected tags + checkbox list -->
        <div class="atn-space-assign-records-to-cluster-modal__header">
          <span
            ><b>{{ recordsSectionTitle }}</b></span
          >
        </div>
        <div
          class="atn-space-assign-records-to-cluster-modal__selection-section"
        >
          @if (selectedRecords.length > 0) {
            <div class="atn-space-assign-records-to-cluster-modal__selected">
              @for (record of selectedRecords; track record.id) {
                <atn-ds-tag
                  [text]="getRecordLabel(record)"
                  (close)="removeSelectedRecord(record.id)"
                />
              }
            </div>
          }

          <div class="atn-space-assign-records-to-cluster-modal__rooms">
            @if (isLoading) {
              <div
                class="atn-space-assign-records-to-cluster-modal__rooms-loading"
              >
                <atn-ds-loader />
              </div>
            } @else {
              @for (record of records; track record.id) {
                <div class="atn-space-assign-records-to-cluster-modal__row">
                  <atn-ds-checkbox
                    [selected]="isRecordSelected(record.id)"
                    (selectedChange)="
                      recordCheckboxChangedHandler(record.id, $event)
                    "
                    [label]="getRecordLabel(record)"
                  />
                </div>
              } @empty {
                <div
                  class="atn-space-assign-records-to-cluster-modal__rooms-empty"
                >
                  No records available
                </div>
              }
            }
          </div>
        </div>
      </div>

      <div
        class="atn-space-assign-records-to-cluster-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!selectedRecords.length"
          [loading]="isSubmitting"
        >
          Save
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
